module.exports = __webpack_public_path__ + "resources/icon_blue_p.1a7564f71044e448.png";